import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { DynamicContentItemService } from './dynamic-content-item.service'
import { DynamicContentItemEffects } from './dynamic-content-item.effects'
import * as fromDynamicContentItem from './dynamic-content-item.reducer'

@NgModule({
  imports: [
    StoreModule.forFeature(
      fromDynamicContentItem.FEATURE_NAME,
      fromDynamicContentItem.dynamicContentItemReducer
    ),
    EffectsModule.forFeature([DynamicContentItemEffects])
  ],
  providers: [DynamicContentItemService]
})
export class DynamicContentItemModule {}
